import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, SHARED_AUDIT_FEATURE } from '.';

const getSharedAuditState = createFeatureSelector<State>(SHARED_AUDIT_FEATURE);

const getSharedState = createSelector(getSharedAuditState, state => state.shared);

const getEnableAudit = createSelector(getSharedState, state => state.enableAudit);
const getShowAuditDrawer = createSelector(getSharedState, state => state.showAuditDrawer);
const getAuditScreen = createSelector(getSharedState, state => state.auditScreen);
const getAuditScreens = createSelector(getSharedState, state => state.auditScreens);
const getSelectedAuditScreen = createSelector(getSharedState, state => state.selectedAuditScreen);

export const sharedAuditQuery = {
  getEnableAudit,
  getShowAuditDrawer,
  getAuditScreen,
  getAuditScreens,
  getSelectedAuditScreen
};
